import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
var router = new Router({
	routes: [
		{
			path: '/',
			name: 'login',
			component: () => import('@/view/Login.vue'), // 登录页
		},
		{
			path: "/dashboard",
			name: 'home',
			component: () => import('@/view/home/index.vue'), // 首页
			redirect: '',
			children: [{
				path: "/dashboard",
				name: 'dashboard',
				component: () => import('@/view/home/dashboard.vue') // dashboard
			}, {
				path: "/SystemSettings",
				name: 'SystemSettings',
				component: () => import('@/view/systemSettings/SystemSettings.vue') // 系统设置
			}, {
				path: "/InfoNotice",
				name: 'InfoNotice',
				component: () => import('@/view/infoNoticeManage/index.vue') // 资讯公告
			}, {
				path: "/questionBank",
				name: 'questionBank',
				component: () => import('@/view/learnManage/questionBank.vue') // 题库管理
			}, {
				path: "/examPaper",
				name: 'examPaper',
				component: () => import('@/view/learnManage/examPaper.vue') // 题库管理
			}, {
				path: "/learnRecord",
				name: 'learnRecord',
				component: () => import('@/view/learnManage/learnRecord.vue') // 学习记录
			}, {
				path: "/jobHuntManage",
				name: 'jobHuntManage',
				component: () => import('@/view/demandManage/jobHuntManage.vue') // 求职管理
			}, {
				path: "/recruitManage",
				name: 'recruitManage',
				component: () => import('@/view/demandManage/recruitManage.vue') // 招工管理
			}, {
				path: "/feeStandard",
				name: 'feeStandard',
				component: () => import('@/view/systemManage/feeStandard.vue') // 收费标准
			}, {
				path: "/accountManage",
				name: 'accountManage',
				component: () => import('@/view/systemManage/accountManage.vue') // 账户管理
			}, {
				path: "/roleManage",
				name: 'roleManage',
				component: () => import('@/view/systemManage/roleManage.vue') // 角色管理
			}, {
				path: "/menuManage",
				name: 'menuManage',
				component: () => import('@/view/systemManage/menuManage.vue') // 菜单管理
			}, {
				path: "/examRegister",
				name: 'examRegister',
				component: () => import('@/view/examRegister/examRegister.vue') // 考试登记
			}, {
				path: "/jobHuntAudit",
				name: 'jobHuntAudit',
				component: () => import('@/view/demandAudit/jobHuntAudit.vue') // 求职审核
			}, {
				path: "/recruitAudit",
				name: 'recruitAudit',
				component: () => import('@/view/demandAudit/recruitAudit.vue') // 招工审核
			}, {
				path: "/swiperSet",
				name: 'swiperSet',
				component: () => import('@/view/swiperSet/swiperSet.vue') // 轮播设置
			}, {
				path: "/memberRecord",
				name: 'memberRecord',
				component: () => import('@/view/memberManage/memberRecord.vue') // 会员记录
			}, {
				path: "/buyRecord",
				name: 'buyRecord',
				component: () => import('@/view/memberManage/buyRecord.vue') // 购买记录
			},]


		}, {
			path: "/Login",
			name: 'Login',
			component: () => import('@/view/Login.vue')
		},
	]
});
//防止路由重复加载报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
// router.onError((error) => {
//     const jsPattern = /Loading chunk (\S)+ failed/g
//     const cssPattern = /Loading CSS chunk (\S)+ failed/g
//     const isChunkLoadFailed = error.message.match(jsPattern || cssPattern)
//     const targetPath = router.history.pending.fullPath
//     if (isChunkLoadFailed) {
//         localStorage.setItem('targetPath', targetPath)
//         window.location.reload()
//     }
// })
// router.onReady(() => {
//     const targetPath = localStorage.getItem('targetPath')
//     const tryReload = localStorage.getItem('tryReload')
//     if (targetPath) {
//         localStorage.removeItem('targetPath')
//         if (!tryReload) {
//             router.replace(targetPath)
//             localStorage.setItem('tryReload', true)
//         } else {
//             localStorage.removeItem('tryReload')
//         }
//     }
// })
export default router;